import {fetchPaymentPage} from "./app";

const FETCH_CREATE_PAYMENT_START = 'FETCH_CREATE_PAYMENT_START'
const FETCH_CREATE_PAYMENT_SUCCESS = 'FETCH_CREATE_PAYMENT_SUCCESS'
const FETCH_CREATE_PAYMENT_FAILURE = 'FETCH_CREATE_PAYMENT_FAILURE'


const createPaymentStart = () => {
    return {
        type: FETCH_CREATE_PAYMENT_START
    }
}

const createPaymentSuccess = (paymentInfo) => {
    return {
        type: FETCH_CREATE_PAYMENT_SUCCESS,
        payload: paymentInfo
    }
}

const createPaymentError = ({message}) => {
    return {
        type: FETCH_CREATE_PAYMENT_FAILURE,
        payload: message
    }
}

const fetchCreatePayment = (loanService, dispatch) => (accessToken, paymentData) => {
    dispatch(createPaymentStart())
    loanService.createPayment(accessToken, paymentData)
        .then((data) => {
            dispatch(createPaymentSuccess(data))
            fetchPaymentPage(dispatch)()
        })
        .catch((err) => dispatch(createPaymentError(err)));
}

export {
    FETCH_CREATE_PAYMENT_START,
    FETCH_CREATE_PAYMENT_SUCCESS,
    FETCH_CREATE_PAYMENT_FAILURE,
    fetchCreatePayment,
}

